import * as utils from "./misc.js";
import * as plugins from "./plugins.js";
import * as tracking from "./tracking.js";

export function swapimg(el, overout) {
  el = jQuery(el);

  var original = el.find(".originalimg");

  //var thishoverimage = jQuery(".hoverimage[data-a="+thisa+"]");
  var hoverel = el.parent(".hoverimage");
  var thishoverimage = hoverel.data("hoverimage");
  //console.log("hoverimage:" + thishoverimage);

  if (thishoverimage != "" && typeof thishoverimage != "undefined") {
    if (overout == "hover") {
      hoverel.css("background-image", "url('" + thishoverimage + "')");
      //thishoverimage.css("opacity",100)
      original.css("opacity", 0);
    } else {
      original.css("opacity", 100);
      el.css("background-image", "none");
    }
  }
}

export function init() {
  jQuery(".wp-post-image").on("mouseover", swapimg(this, "hover"));
  jQuery(".wp-post-image").on("mouseout", swapimg(this, "out"));

  jQuery(".grid-item").on("mouseover", function () {
    swapimg(this, "hover");
  });
  jQuery(".grid-item").on("mouseout", function () {
    swapimg(this, "out");
  });

  jQuery("*[data-vc-full-width]").addClass("vc_fullwidth");

  if (utils.isMobile()) {
    jQuery(".mobilebanner").each(function () {
      jQuery(this).attr("src", jQuery(this).attr("mobile-src"));
      jQuery(this).attr("srcset", jQuery(this).attr("mobile-srcset"));
    });
  } else {
    jQuery(".desktopbanner").each(function () {
      jQuery(this).attr("src", jQuery(this).attr("desktop-src"));
      jQuery(this).attr("srcset", jQuery(this).attr("desktop-srcset"));
    });
  }

  // jQuery('.search-action a').magnificPopup({
  //     type: 'inline',
  //     mainClass: 'mfp-zoom-in',
  //     items: { src: '#search-fullwidth' },
  //     focus: 'input[name=s]',
  //     removalDelay: 200
  // });

  // jQuery(".searchform input[name='s']").keyup(utils.delay(function (e) {
  //     var s = jQuery(".searchform input[name='s']").val();
  //     var searchdiv;
  //     //send to ajax

  //     jQuery.post(base.ajaxurl, {
  //         action: "woo_getproducts",
  //         args: { s: s, perpage: -1, showfilters: false, lazyload: false }
  //     }, function (r) {
  //         var r = JSON.parse(r);
  //         jQuery(".ajaxsearchresults").remove();
  //         searchdiv = "<div class='ajaxsearchresults'><ul class='products list'>" + r.productsHTML + "</ul></div>";
  //         jQuery(searchdiv).appendTo(".searchform");
  //         plugins.init_lazyload();
  //     });
  // }, 500));

  jQuery("*[data-href]").on("click", function () {
    var thisurl = jQuery(this).data("href");
    if (thisurl) {
      window.location = thisurl;
    }
  });

  // jQuery(document).on("click", function () {
  //     var thisurl = jQuery(this).data("href");
  //     if (thisurl) {
  //         window.location = thisurl;
  //     }
  // })

  // jQuery("button[name='resetpassword']").on("click", function () {
  //     resetpassword();
  // });

  jQuery(".logout").on("click", function () {
    logout();
  });

  jQuery(".showhide_button").on("click", function () {
    jQuery(this).siblings(".showhide_content").toggleClass("open");
    jQuery(this).toggleClass("open");
    if (jQuery(this).hasClass("open")) {
      jQuery(this).html("Read Less");
    } else {
      jQuery(this).html("Read More");
    }
  });

  jQuery(".container").on(
    "click",
    ".gform_button.button[type='submit']",
    function () {
      jQuery(this).val("Please Wait...");
    }
  );

  jQuery("*[data-scrollto]").on("click", function () {
    utils.scrollClick(this);
  });

  jQuery("#zip-tagline").remove();
  jQuery("#ppcp-messages").remove();
  jQuery("afterpay-placement").remove();

  jQuery("form#commentform").attr("enctype", "multipart/form-data");

  jQuery("input[name='myaddress']").on("blur", function () {
    var thisadd = jQuery(this).val();

    if (thisadd != "") {
      jQuery.get(
        "https://maps.googleapis.com/maps/api/place/autocomplete/json?input=" +
          thisadd +
          "&types=geocode&key=AIzaSyDZz92zR7Wlxly-6PP0pGH5l7wqIS4u-LU",
        function (r) {
          console.dir(r);

          var r = JSON.parse(r);
          if (r.r == "notfound") {
            jQuery(".sendresetresult").html(
              "Sorry, we couldn't find those details."
            );
            emailfield.addClass("error");
          } else {
            jQuery(".sendresetresult").html(
              "Thanks. We have send you a reset email."
            );
            jQuery(".sendresetform").hide();
          }
        }
      );
    }
  });

  var footerpopup = sessionStorage.getItem("cc_popupid_footerpopup");
  if (!footerpopup) {
    jQuery(".signuppopup").removeClass("hide");
  }

  jQuery(".signuppopupcontent .icon_close").on("click", function () {
    sessionStorage.setItem("cc_popupid_footerpopup", new Date());
    jQuery(".signuppopup").addClass("hide");
  });
}

/* ---------------------------------------------
 POPUPS
 --------------------------------------------- */
// export function get_popup() {
//     var cookie_popup = utils.getCookie('popup_' + base.currentpageid);
//     console.log("getting popup: " + cookie_popup + " " + jQuery(".popupcontent").length);

//     if (jQuery(".popupcontent").length > 0 && cookie_popup != 1) {

//         var popupid = jQuery(".popupcontent").attr("data-popupid");

//         var popupcontent = `<div class="themedev-popup mfp-with-anim"><div class="popupcontent">` + jQuery(".popupcontent").html() + `</div></div>`;

//         if (utils.isnull(utils.getCookie('cc_popupid_' + popupid))) {
//             jQuery.magnificPopup.open({
//                 items: {
//                     alignTop: true,
//                     overflowY: 'scroll',
//                     src: popupcontent,
//                     type: 'inline'
//                 },
//                 callbacks: {
//                     open: function () {

//                         var $popup = jQuery('.themedev-popup');

//                         jQuery(".productpopup .close-quickview .fa-times").on('click', function (e) {
//                             e.preventDefault();
//                             jQuery.magnificPopup.close();
//                         });

//                         setTimeout(function () {
//                             $popup.addClass('animate-width');
//                         }, 500);
//                         setTimeout(function () {
//                             $popup.addClass('add-content');
//                         }, 1000);
//                     },

//                 },
//             });
//         }
//     }

//     var today = new Date();
//     utils.setCookie('cc_popupid_' + popupid, today);

// }
